import React from 'react';

const LeftRight = ({ className }) => {
    return (
        <svg
            className={className}
            width={200}
            height={117}
            viewBox="0 0 200 117"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            //{...props}
        >
            <mask
            id="mask0_2017_101"
            style={{
                maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={200}
            height={117}
            >
            <path
                d="M193.822 0H6.17788C2.7689 0 0.00537109 2.76353 0.00537109 6.17251V110.796C0.00537109 114.205 2.7689 116.969 6.17788 116.969H193.822C197.231 116.969 199.995 114.205 199.995 110.796V6.17251C199.995 2.76353 197.231 0 193.822 0Z"
                fill="white"
            />
            </mask>
            <g mask="url(#mask0_2017_101)">
            <path
                d="M193.822 0H6.17788C2.7689 0 0.00537109 2.76353 0.00537109 6.17251V110.796C0.00537109 114.205 2.7689 116.969 6.17788 116.969H193.822C197.231 116.969 199.995 114.205 199.995 110.796V6.17251C199.995 2.76353 197.231 0 193.822 0Z"
                fill="#404040"
            />
            <path
                d="M30.4824 60.1566L20.0765 72.5785C16.6494 76.6693 19.558 82.9001 24.8947 82.9001H75.2205C80.0496 82.9001 83.0747 77.681 80.6745 73.4905L68.8104 52.7792C66.6768 49.0548 61.5206 48.5171 58.6643 51.7213L50.6018 60.7662C48.3778 63.2611 44.5901 63.5793 41.9813 61.4902L39.2293 59.2866C36.5621 57.1506 32.6768 57.537 30.4824 60.1566Z"
                fill="#818181"
            />
            <path
                opacity={0.18}
                d="M18.06 72.8358C47.9738 72.8358 72.2237 48.5859 72.2237 18.672C72.2237 -11.2418 47.9738 -35.4917 18.06 -35.4917C-11.8538 -35.4917 -36.1038 -11.2418 -36.1038 18.672C-36.1038 48.5859 -11.8538 72.8358 18.06 72.8358Z"
                fill="#E66819"
            />
            <path
                d="M18.0601 30.5542C24.6223 30.5542 29.9421 25.2344 29.9421 18.6721C29.9421 12.1098 24.6223 6.79004 18.0601 6.79004C11.4978 6.79004 6.17798 12.1098 6.17798 18.6721C6.17798 25.2344 11.4978 30.5542 18.0601 30.5542Z"
                fill="#E66819"
            />
            <path d="M213.265 0H98.4568V116.969H213.265V0Z" fill="#F4F0EC" />
            <path
                d="M113.58 37.6523H149.072"
                stroke="#404040"
                strokeWidth={4.62938}
                strokeLinecap="round"
            />
            <path
                d="M113.58 48.146H169.749"
                stroke="#B7B7B7"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M140.43 55.2441H157.713"
                stroke="#B7B7B7"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M113.58 55.2441H133.332"
                stroke="#B7B7B7"
                strokeWidth={3.08625}
                strokeLinecap="round"
            />
            <path
                d="M144.678 67.8979H114.169C112.821 67.8979 111.728 68.9907 111.728 70.3387V76.6847C111.728 78.0327 112.821 79.1255 114.169 79.1255H144.678C146.026 79.1255 147.119 78.0327 147.119 76.6847V70.3387C147.119 68.9907 146.026 67.8979 144.678 67.8979Z"
                fill="#E66819"
            />
            <path
                d="M121.735 73.3896H136.868"
                stroke="white"
                strokeWidth={2.44076}
                strokeLinecap="round"
            />
            <path
                d="M183.974 67.8979H153.465C152.117 67.8979 151.024 68.9907 151.024 70.3387V76.6847C151.024 78.0327 152.117 79.1255 153.465 79.1255H183.974C185.322 79.1255 186.415 78.0327 186.415 76.6847V70.3387C186.415 68.9907 185.322 67.8979 183.974 67.8979Z"
                fill="#767676"
            />
            <path
                d="M161.031 73.3896H176.164"
                stroke="white"
                strokeWidth={2.44076}
                strokeLinecap="round"
            />
            </g>
        </svg>
    )
}

export default LeftRight;